import { render, staticRenderFns } from "./OtpVerificationMainPage.vue?vue&type=template&id=27ccc64b&scoped=true&"
import script from "./OtpVerificationMainPage.vue?vue&type=script&lang=js&"
export * from "./OtpVerificationMainPage.vue?vue&type=script&lang=js&"
import style0 from "./OtpVerificationMainPage.vue?vue&type=style&index=0&id=27ccc64b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ccc64b",
  null
  
)

export default component.exports